import { CheckCircleOutline, CloseOutlined } from '@mui/icons-material';
import { Box, Button, IconButton, Link, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


export default function SuccessDialog({ successDialogOpen, setSuccessDialogOpen, primarySucessMessage, secondarySucessMessage, urlLink, urlMessage, agentName = null }) {
    return (
        <Dialog
            open={successDialogOpen}
            onClose={() => setSuccessDialogOpen(false)}
            PaperProps={{
                sx: {
                    borderRadius: '15px',
                    padding: '20px',
                    backgroundColor: '#f8f9fa',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                    minWidth: '400px'
                }
            }}
        >
            <Stack direction="row" justifyContent="end" alignItems="center">
                <IconButton onClick={() => setSuccessDialogOpen(false)}>
                    <CloseOutlined sx={{fill:'#000'}}/>
                </IconButton>

            </Stack>

            <DialogContent sx={{ textAlign: 'center' }}>
                <CheckCircleOutline sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
                {primarySucessMessage && (<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
                    {primarySucessMessage}
                </Typography>)
                }
                {
                    secondarySucessMessage && (<Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                        {secondarySucessMessage}
                    </Typography>)
                }

                {urlLink && (
                    <Box mt={2}>
                        <Typography variant="body2">
                            {urlMessage}:
                        </Typography>
                        <Link href={urlLink} target="_blank" rel="noopener noreferrer">
                            {urlLink}
                        </Link>
                    </Box>
                )}
            </DialogContent>
            {/* {
                !agentName && (
                    <DialogActions sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
                        <Button
                            onClick={() => setSuccessDialogOpen(false)}
                            variant="contained"
                            autoFocus
                            sx={{
                                backgroundColor: 'success.main',
                                '&:hover': { backgroundColor: 'success.dark' },
                                borderRadius: '20px',
                                padding: '10px 25px',
                                textTransform: 'none',
                                fontWeight: 'bold'
                            }}
                        >
                            Awesome!
                        </Button>
                    </DialogActions>
                )
            } */}

        </Dialog>
    )
}